<template>
  <v-app>
    <v-main class="navy lighten-3 primary--text">
      <v-container>
        <v-tabs background-color="transparent" class="c-tabs mb-6">
          <v-tab v-for="tab in tabs" :key="tab.route" :to="tab.route">
            {{ tab.text }}
          </v-tab>
        </v-tabs>
        <h1 v-if="title" v-text="title" class="text-h1 font-weight-bold mb-12">
          Heading 1
        </h1>
        <slot />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  props: {
    title: String,
  },
  data() {
    return {
      tabs: [
        { text: "Barevná paleta", route: "/design-system/colors" },
        { text: "Typografie", route: "/design-system/typography" },
        { text: "Formuláře", route: "/design-system/forms" },
        { text: "Tlačítka", route: "/design-system/buttons" },
      ],
    }
  },
}
</script>
